import { t, useI18n } from "@bookingcom/lingojs-react";
import useProfiler from "../../../../../hooks/useProfiler.js";
import useSearchFiltersController from "../../useSearchFiltersController.js";
import { useSelector } from "react-redux";
import { getSearchResultsHidePrice } from "../../../../../store/searchResults/selectors.js";
import { useTrackLayoverPriceAirportFilterWeb } from "../../../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
export const useStopsFilterController = () => {
    const i18n = useI18n();
    const { isMeta, isMobile } = useProfiler();
    const { stops } = useSearchFiltersController();
    const isRoundPrice = !isMeta() && isMobile();
    const hidePriceForStaggeredSearch = useSelector(getSearchResultsHidePrice);
    const trackLayoverPriceAirportFilterWeb = useTrackLayoverPriceAirportFilterWeb();
    return {
        isFilterAvailable: stops.options.length > 0,
        title: i18n.trans(t("flights_filters_stops_title")),
        resetLabel: i18n.trans(t("flights_filter_reset")),
        showReset: trackLayoverPriceAirportFilterWeb() ? false : stops.touched,
        onClickReset: stops.reset,
        value: stops.value,
        onChange: stops.set,
        gapBetweenOptions: isMobile() ? 4 : 2,
        options: stops.options.map((o) => ({
            ...o,
            priceLabel: hidePriceForStaggeredSearch
                ? ""
                : i18n.trans(t("flights_filters_lowest_price", {
                    variables: {
                        lowest_price: isRoundPrice ? o.roundPrice : o.price
                    }
                }))
        }))
    };
};
